import { useState, useEffect } from "react";
import {
  Typography,
  Button,
  TextField,
  Autocomplete,
  Box,Card, CardHeader} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { externalgetApi, externalpostApi } from "../../services/externalApis";
import {
  SETTING_API_03, SUPPLIER_API_09
} from "../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import SystemAlert from "../../components/common/SystemAlert";
import Upload from "../common/Upload";
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import PreviewIcon from '@mui/icons-material/Preview';
function SupplierAgreement({ suprefcode }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [fileName, setFileName] = useState("");
  const [attachAnchor, setAttachAnchor] = useState(null);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { STAFFMAPLOCODE, COMPCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const [showAttachments, setShowAttachments] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [data, setData] = useState(null);
  const [datadoc, setDatadoc] = useState(null);
  const [error, setError] = useState({});
  const [filePath, setFilePath] = useState("");
  const [croppedImg, setCroppedImg] = useState("");
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const handleRowSelection = (ids) => {
    setSelectedIds(ids);
  };

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    supdoccode: "",
    doctypecode: "",
    doctype: "",
    docnamenext: "",
    docpathjson: "",
    bytearray: "",
    description:"",
  });

  // For menu on each attachment

  const [doctypeOptions, setDoctypeOptions] = useState([]);
  const [selectedDoctype, setSelectedDoctype] = useState(null);
// In SupplierAgreement.jsx


  useEffect(() => {
    const fetchDoctypes = async () => {
      try {
        const result = await externalgetApi(SETTING_API_03, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,
          DOCCATCODE: "2",
          STS: CON_STATUS_ACTIVE,
        });
        setDoctypeOptions(result); // result should be an array of doctypes
      } catch (err) {
        console.error("Error fetching doctypes:", err);
      }
    };

    fetchDoctypes();
  }, []);


  const fetchDatadoc = async () => {
  try {
    const result = await externalgetApi(SUPPLIER_API_09, "get", {
      suprefcode: suprefcode,
      STS: CON_STATUS_ACTIVE,
    });

    // Format expdate for each row
    const formattedResult = (result || []).map((row) => ({
      ...row,
      expdate: row.expdate ? dayjs(row.expdate).format("YYYY-MM-DD") : "",
    }));

    setData(formattedResult);
    setFilteredRows(formattedResult);
    console.log("result", formattedResult);

  } catch (err) {
    setError(err);
  }
};
    useEffect(() => {
 
      fetchDatadoc();
    }, [suprefcode])

const [filteredRows, setFilteredRows] = useState([]); // <-- was ""

  const groupByDoctype = (rows = []) => {
  return rows.reduce((groups, row) => {
    const key = row.doctype || "Other";
    if (!groups[key]) groups[key] = [];
    groups[key].push(row);
    return groups;
  }, {});
};

const groupedDocs = groupByDoctype(filteredRows);


// ...existing code...

;

  // const [filteredRows, setFilteredRows] = useState(SupplierAttachmentData.rows);

  const handleItemClick = () => {};

  const handleCroppedImage = (img) => {
    setCroppedImg(img);

    console.log("Received cropped image from child:", img);
  };

  const handleConfirmClick = async () => {
    const { doctypecode,docpathjson } = selectedItemDetails;

    const requiredFields = [
      { name: "doctypecode", label: "Document Type", value: doctypecode },
      { name: "docpathjson", label: "Attachment", value: docpathjson },
   

    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert

      return;
    }

    // if (data) {
    //   const isDuplicate = data.some((item) => {
    //     if (
    //       item.supdoccode !== selectedItemDetails.supdoccode &&
    //       item.packagename.toLowerCase() === packagename.toLowerCase()
    //     ) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   });

    //   if (isDuplicate) {
    //     setAlertMessage("Package Already Exists.");
    //     setAlertType("warning");

    //     setAlertOpen(true); // Open the alert
    //     return;
    //   }
    // }

    // const BRAND_CODE = selectedItem ? (selectedItem.supdoccode) : 0;

    const staticValues = {
      COMPCODE,
      businesstypecode: "o",

      docpathjson: "",
      suprefcode: suprefcode,
      docnamenext:filePath,
    
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
      endate: new Date().toISOString(),
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      supdoccode: 0,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SUPPLIER_API_09, payload);
      console.log("Success:", responseData);
      setAlertMessage("Created Successfully!");
      setAlertType("success");

      setAlertOpen(true);
      handleClear(); // Clear the form after successful creation
      fetchDatadoc(suprefcode); // Refresh the data after successful creation
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
  };

  const handleClear = () => {
  setSelectedItemDetails({
    supdoccode: "",
    doctypecode: "",
    doctype: "",
    docnamenext: "",
    docpathjson: "",
    bytearray: "",
    description: "",
    expdate: "",
  });
  setSelectedDoctype(null);
  setFileName(" ");
  setFilePath("");
  
};

const handleDeleteAttachment = async (doc) => {
  try {
    const payload = {
      ...doc,
      COMPCODE,
      byteArray:"",
      BUSINESSTYPECODE:"O",
      STS: "D", // Pass D as STS
    };
    await externalpostApi(SUPPLIER_API_09, payload);
    setAlertType("success");
    setAlertMessage("Attachment Deleted Successfully!");
    setAlertOpen(true);
    fetchDatadoc(suprefcode); // Refresh the list
  } catch (error) {
    setAlertType("error");
    setAlertMessage("Delete failed.");
    setAlertOpen(true);
  }
};
  const menuItems = [
    {
      text: "Remove",
      icon: <VisibilityOutlinedIcon />,
      onClick: (MENUCODE) => handleItemClick(MENUCODE, "View"),
    },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

const handleFileSelect = (filePath, byteArray) => {
  console.log("File Path:", filePath);
  console.log("Byte Array (base64):", byteArray);

  setFileName(filePath); // <-- update the parent fileName state
  setFilePath(filePath);
  setSelectedItemDetails((prev) => ({
    ...prev,
    docpathjson: filePath,
    bytearray: byteArray ? String(byteArray.split(",")[1]) : "",
  }));
};
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        // height="60vh"
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{ ...styles.add_form_page_container, mb: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
              <Typography sx={styles.supplier_sub_title_text}>
                {/* Amendment And Annexures */}
                Attachements
              </Typography>
            </Grid>
            <Grid
              container
              spacing={2}
              size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
            >
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <Autocomplete
  options={doctypeOptions}
  getOptionLabel={(option) => option.doctype || ""}
  value={
    selectedDoctype ||
    doctypeOptions.find(
      (opt) => String(opt.doctypecode) === String(selectedItemDetails.doctypecode)
    ) ||
    null
  }
  onChange={(_, newValue) => {
  setSelectedDoctype(newValue);
  setSelectedItemDetails((prev) => ({
    ...prev,
    doctypecode: newValue ? newValue.doctypecode : "",
    doctype: newValue ? newValue.doctype : "",
  }));
  if (newValue) {
    setError((prev) => ({
      ...prev,
      doctypecode: "",
      doctype: "",
    }));
  }
}}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Document Type"
      variant="outlined"
      size="small"
      required
      error={!!error.doctypecode}
      helperText={error.doctypecode || ""}
      FormHelperTextProps={{
        sx: { fontSize: "12px", color: "red" }, // Customize font size and color
      }}
    />
  )}
  fullWidth
  size="small"
/>
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
             <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    id="exp date"
    label="Expiry Date"
    value={
      selectedItemDetails.expdate
        ? dayjs(selectedItemDetails.expdate)
        : null
    }
    onChange={(newValue) => {
      handleInputChange({
        target: {
          name: "expdate",
          value: newValue
            ? dayjs(newValue).format("YYYY-MM-DD")
            : "",
        },
      });
    }}
    disablePast // <-- This disables all dates before today
    slotProps={{
      textField: { fullWidth: true, size: "small" },
    }}
  />
</LocalizationProvider>
              </Grid>

              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <Box>
                 <Upload
  MAX_FILESIZE={5 * 1024 * 1024}
  onFileSelect={handleFileSelect}
  setSnackbarMessage={setAlertMessage}
  setOpenErrorSnackbar={setAlertOpen}
  setFilePath={setFilePath}
  fileName={fileName}
  setFileName={setFileName}
 
/>
                  {/* <TextField
                    variant="outlined"
                    disabled
                    fullWidth
                    value={fileName}
                    size="small"
                    sx={styles.ipt_file_attach}
                  /> */}
                </Box>
              </Grid>
              <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <TextField
                  label="Description"
                  variant="outlined"
                
                  fullWidth
                  size="small"
                  name="description"
                  value={selectedItemDetails.description || ""}
                  onChange={handleInputChange}
                  error={!!error.description}
                  helperText={error.description || ""}
                 
                  FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
                
                />
              </Grid>

              <Grid
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
              >
                 <Button
    variant="outlined"
    size="medium"
    sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
    onClick={handleClear}
  >
    Clear
  </Button>
                <Button
                  variant="contained"
                  size="medium"
                  sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
                  onClick={handleConfirmClick}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        
<Box sx={{ mb: 2, mt: 2 }}>
  <Grid container spacing={2}>
    {Object.entries(groupedDocs).map(([doctype, docs], idx) => (
      <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }} key={doctype}>
        <Card sx={styles.db_card}>
          <CardHeader title={doctype} sx={{ pb: 0, mb: 0 }} />
         
       
            {docs.map((doc) => (
              // <Box key={doc.supdoccode} sx={{ mb: 1 }}>
              //   <Typography variant="body2">
              //     <strong>Description:</strong> {doc.description || "-"}
              //   </Typography>
              //   <Typography variant="body2">
              //     <strong>Expiry Date:</strong> {doc.expdate || "-"}
              //   </Typography>
              //   <Typography variant="body2">
              //     <strong>Attachment:</strong>{" "}
              //     {doc.docpathjson ? (
              //       <a href={doc.docpathjson} target="_blank" rel="noopener noreferrer">
              //         View
              //       </a>
              //     ) : (
              //       "-"
              //     )}
              //   </Typography>
              //   <Divider sx={{ my: 1 }} />
              // </Box>
          

               <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={3}
              xl={3}
              mt={4}
           key={doc.supdoccode} 
            >
              <Card
                sx={{
                  backgroundColor: "background.paper",
                  boxShadow: 2,
                  borderRadius: 1,
                  padding: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  "&:hover": {
                    boxShadow: 6,
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  {/* Icon Container */}
                <Box
  sx={{
    width: 48,
    height: 48,
   
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "12px",
    color: "white",
      overflow: "hidden",
    ...(doc.docpathjson && /\.(jpe?g|png|gif|bmp|webp)$/i.test(doc.docpathjson)
      ? {}
      : { backgroundColor: theme.palette.primary.main }),
  }}
 
>
  {doc.docpathjson && /\.(jpe?g|png|gif|bmp|webp)$/i.test(doc.docpathjson) ? (
    <img
      src={doc.docpathjson}
      alt="attachment"
      style={{ width: "100%", height: "100%", objectFit: "cover" }}
    />
  ) : (
 
    <FileCopyOutlinedIcon sx={{ fontSize: 32 ,   backgroundColor: theme.palette.primary.main,}} />
  )}
</Box>
                  {/* Text Content */}
<Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center",}}>
  <Typography
    variant="body2"
    sx={{ color: "text.secondary", fontWeight: 500 }}
  >
    Expiry Date :
  </Typography>
  <Typography
    variant="body2"
    sx={{ color: "text.secondary", fontWeight: 500, mt: 1 }}
  >
    Description :
  </Typography>
</Box>

<Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center",  }}>
  <Typography
    variant="body2"
    sx={{ color: "text.secondary", fontWeight: 500 ,}}
  >
 {doc.expdate || "-"}
  </Typography>
  <Typography
    variant="body2"
    sx={{ color: "text.secondary", fontWeight: 500, mt: 1 }}
  >
 {doc.description || "-"}
  </Typography>
</Box>



                </Box>
                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Tooltip title="Preview Attachment">
    <Button
      size="small"
      color="primary"
      onClick={() => window.open(doc.docpathjson, "_blank")}
      sx={{ minWidth: 0, p: 1 }}
    
    >
      <PreviewIcon />
    </Button></Tooltip>
    <Tooltip title="Delete">
    <Button
      size="small"
      color="error"
       onClick={() => handleDeleteAttachment(doc)}
      sx={{ minWidth: 0, p: 1 }}
    >
      <DeleteIcon /> {/* Replace with DeleteIcon if you want */}
    </Button></Tooltip>
  </Box>
              </Card>
            </Grid>
             ))}
        
        </Card>
      </Grid>
    ))}
  </Grid>
</Box>
              {/* ))} */}
              {/* </Box> */}
            </Grid>
          </Grid>
        </Box>

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
    </>
  );
}

export default SupplierAgreement;
